<template>
  <add-edit-dialog>
    <crm-panel title="编辑商机">
      <div class="page-buttons">
        <crm-button :text="'保存'" :loading="loading" @click="handleSave()"> </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleCancel()">
        </crm-button>
      </div>
      <div class="sub-header">
        <span>基本信息</span>
        <span>商机编码:{{ editForm.businessNo }}</span>
      </div>
      <el-form
        label-width="160px"
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="客户名称："
              prop="customerName"
              :rules="{ required: true }"
            >
              <el-input v-model="editForm.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商机名称：" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="预计成交金额(元)：" prop="dealAmountStr">
              <el-input v-model="editForm.dealAmountStr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计成交日期：" prop="dealDateStr">
              <el-date-picker
                format="yyyy-MM-dd"
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="editForm.dealDateStr"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="客户意向：" prop="intention">
              <el-input type="textarea" :rows="4" v-model="editForm.intention">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人：" prop="converts">
              <el-select
                multiple
                clearable
                v-model="editForm.converts"
                @change="changeConverts"
                @remove-tag="removeContactDepa"
              >
                <el-option
                  :key="item.uid"
                  v-for="item in contactsSelect"
                  :label="`${item.name}${
                    item.contactDepa ? ' - ' + item.contactDepa : ''
                  }`"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="备注：" prop="remarks">
              <el-input type="textarea" :rows="6" v-model="editForm.remarks"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="sub-header">
        <span>产品线(至少添加一个产品线)</span>
        <crm-button
          v-if="
            businessAuth.bizProductLineAdd && businessAuth.bizProductLineAdd.toggleStatus
          "
          :size="'mini'"
          type="text"
          :text="'添加'"
          @click="handleAddProduct()"
        >
        </crm-button>
      </div>
      <el-table :data="editForm.businessLineList" height="170" border style="width: 100%">
        <el-table-column
          show-overflow-tooltip
          label="产品线名称"
          prop="name"
          align="center"
        >
        </el-table-column>
        <el-table-column label="产品线预计成交金额(元)" prop="dealAmount" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.dealAmount) }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button
              v-if="
                businessAuth.bizProductLineDel &&
                businessAuth.bizProductLineDel.toggleStatus
              "
              @click="handleDel(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </crm-panel>
    <!-- 新增编辑产品线 -->
    <edit-product-Line
      v-if="isProductLineDialogVisible"
      :visible="isProductLineDialogVisible"
      :detail="productLinetDetail"
      @refresh="refreshProductLine"
      @close="isProductLineDialogVisible = false"
    >
    </edit-product-Line>
  </add-edit-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import CusnameSelect from "@/components/business/custom/cusname-select";
import service from "@/services/api/business";
import EditProductLine from "~component/business/busiopportunity/editProductLine.vue";
import { formatMoney } from "@/scripts/utils";

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CusnameSelect,
    EditProductLine,
  },
  props: {
    visible: { type: Boolean, default: false },
    detail: { type: Object },
    moduleName: { type: String },
  },
  data() {
    const dealAmountStrRule = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写预计成交金额!"));
      } else if (!/^-?\d+\.?\d{0,2}$/.test(value)) {
        callback(new Error("请填写两位小数的数字!"));
      } else if (parseFloat(value) > 99999999999.99) {
        callback(new Error("不能超过99,999,999,999.99"));
      } else {
        callback();
      }
    };
    return {
      // 待提交的表单数据
      editForm: {
        converts: [],
        businessLineList: [],
      },
      contactDepaList: [],
      // 联系人下拉框数据
      contactsSelect: [],
      // 联系人提交
      contactsList: {
        customerUid: "",
        salesmanCode: "",
        pageNumber: 1,
        pageSize: 20,
      },
      // 表单校验规则
      editFormRules: {
        customerId: [{ required: true, message: "请选择客户名称", trigger: "change" }],
        name: [
          { required: true, message: "请填写商机名称", trigger: "change" },
          {
            min: 0,
            max: 30,
            message: "最多30个字",
            trigger: "blur",
          },
        ],
        businessLine: [{ required: true, message: "请选择产品线", trigger: "change" }],
        intention: [
          { required: true, message: "请填写客户意向", trigger: "change" },
          {
            min: 0,
            max: 100,
            message: "最多100个字",
            trigger: "blur",
          },
        ],
        dealAmountStr: [
          { required: true, validator: dealAmountStrRule, trigger: "change" },
        ],
        dealDateStr: [
          { required: true, message: "请填写预计成交日期", trigger: "change" },
        ],
        remarks: [
          {
            min: 0,
            max: 200,
            message: "最多200个字",
            trigger: "blur",
          },
        ],
        converts: [{ required: true, message: "请选择联系人", trigger: "change" }],
      },
      timer: null,
      newBusiLineList: [],
      // 产品线新增编辑弹框
      isProductLineDialogVisible: false,
      productLinetDetail: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      // busiLineList: 'business/busiLineList',
      businessAuth: "authority/businessAuth",
      busiSalesList: "business/busiSalesList",
      busiContacts: "business/busiContacts",
      detailContacts: "business/detailContacts",
    }),
  },
  watch: {
    visible: {
      handler(val) {
        this.getAuthority({ menuUrl: "/business/opportunity" });
        // if (this.busiLineList.length === 0) {
        //   this.getBusiLineList({
        //     pageNumber: 1,
        //     pageSize: 20,
        //     code: 'category_business_line',
        //   });
        // }
        // this.newBusiLineList = JSON.parse(JSON.stringify(this.busiLineList));
        if (val) {
          this.customSalesman = [];
          this.contactsSelect = [];
          this.getBusiContactsList({
            customerUid: this.detail.customerId,
            salesmanCode: this.detail.userId,
            pageNumber: 1,
            pageSize: 20,
          });
          this.editForm = this.detail;
          console.log(this.detail, "this.detail");
          this.editForm.businessLineList = this.detail.productLineList;
          console.log(this.editForm, "this.editForm");
        }
      },
      immediate: true,
    },
    busiSalesList(val) {
      this.customSalesman = val;
    },
    busiContacts(val) {
      this.contactsSelect = val;
      this.contactsSelect.forEach((item) => {
        if (this.editForm.converts.includes(item.uid)) {
          this.contactDepaList.push(item.contactDepa);
        }
      });
      if (this.moduleName === "opportunity") {
        this.checkPermission();
      }
    },
  },
  methods: {
    formatMoney,
    ...mapActions({
      getAuthority: "authority/getAuthority",
      customSelectSearch: "business/CustomSelectSearch",
      getBusiLineList: "business/getBusiLineList",
      saveUpdateBusiOpprtunity: "business/saveUpdateBusiOpprtunity",
      getBusiContactsList: "business/getBusiContactsList",
    }),
    changeBusinessLine() {
      this.contactDepaList = [];
    },
    handleCancel() {
      this.$emit("close");
      // this.busiLineList = JSON.parse(JSON.stringify(this.newBusiLineList));
      this.$refs.editForm.resetFields();
    },
    removeContactDepa(val) {
      const check = this.contactsSelect.find((i) => i.uid === val);
      if (check && this.contactDepaList.includes(check.contactDepa)) {
        let index = 0;
        this.editForm.converts.forEach((item) => {
          if (
            this.contactsSelect.find((i) => i.uid === item).contactDepa ===
            check.contactDepa
          ) {
            index += 1;
          }
        });
        if (index === 0) {
          this.contactDepaList.splice(this.contactDepaList.indexOf(check.contactDepa), 1);
        }
      }
    },
    changeConverts(val) {
      val.forEach((item) => {
        const check = this.contactsSelect.find((i) => i.uid === item);
        if (check && !this.contactDepaList.includes(check.contactDepa)) {
          this.contactDepaList.push(check.contactDepa);
        }
      });

      // if (this.moduleName === 'opportunity') {
      this.checkPermission();
      // }
    },
    handleSave() {
      if (this.editForm.businessLineList.length <= 0) {
        this.$message.error("请至少添加一个产品线！");
        return;
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.editForm.delConverts = [];
          this.editForm.addConverts = [];
          this.detailContacts.results.forEach((item) => {
            const isInData = this.editForm.converts.find(
              (convert) => item.uid === convert
            );
            if (!isInData) this.editForm.delConverts.push(item.uid);
          });
          this.editForm.converts.forEach((convert) => {
            const isInData = this.detailContacts.results.find(
              (item) => convert === item.uid
            );
            if (!isInData) this.editForm.addConverts.push(convert);
          });
          const { converts, ...otherEditParams } = this.editForm;
          this.saveUpdateBusiOpprtunity({ ...otherEditParams }).then(() => {
            this.$message({
              type: "success",
              message: "修改成功！",
            });
            this.$refs.editForm.resetFields();
            this.$emit("close");
            this.$emit("success");
            this.loading = false;
          });
        }
      });
    },
    // 新增校验 在客户名称 业务员 产品线有值的时候 随意更改值都重新校验是否允许新增
    checkPermission() {
      this.timer = setTimeout(() => {
        service
          .apiGetDisabledBusinessLine({
            salesmanCode: this.detail.userId,
            customerId: this.detail.customerId,
            contactDepaList: this.contactDepaList,
          })
          .then((res) => {
            const result = res.data.data;
            // this.busiLineList.forEach((i) => {
            //   i['disabled'] = false;
            //   if (result.includes(i.uid)) {
            //     i['disabled'] = true;
            //   }
            // });
            this.$forceUpdate();
          });
      }, 0);
    },
    // 添加产品线 btn
    async handleAddProduct() {
      if (!this.editForm.customerId || !this.editForm.userId) {
        this.$message.error("请先选择客户名称以及业务员再选择产品线");
        return;
      }
      this.productLinetDetail = {
        id: "",
        type: "add",
        titleName: "添加",
        customerId: this.editForm.customerId,
        salesmanCode: this.editForm.userId,
        contactDepaList: this.contactDepaList,
      };
      this.isProductLineDialogVisible = true;
    },
    refreshProductLine(productLineItem) {
      // 有的覆盖 没有的新增
      if (this.editForm.businessLineList.length === 0) {
        this.editForm.businessLineList.push({
          businessLine: productLineItem.businessLine[1],
          dealAmount: productLineItem.dealAmount,
          name: productLineItem.businessLineName,
        });
      } else {
        this.editForm.businessLineList.forEach((item, index) => {
          if (
            item.businessLine !== productLineItem.businessLine[1] &&
            index >= this.editForm.businessLineList.length - 1
          ) {
            this.editForm.businessLineList.push({
              name: productLineItem.businessLineName,
              businessLine: productLineItem.businessLine[1],
              dealAmount: productLineItem.dealAmount,
            });
          } else if (item.businessLine === productLineItem.businessLine[1]) {
            item.dealAmount = productLineItem.dealAmount;
          }
        });
      }
    },
    handleDel(row) {
      const counter = this.editForm.businessLineList.reduce((counter, newItem) => {
        counter += newItem.id ? 1 : 0;
        return counter;
      }, 0);
      if (this.editForm.businessLineList.length === 1 || counter === 1) {
        this.$message.error("商机至少需要保留一个产品线,如遇新增产品线请保存后再删除！");
        return;
      }
      this.$confirm(
        row.status === "1"
          ? "该产品线已被停用，删除后将无法再次添加，是否继续？"
          : "当前操作将从商机删除该产品线，是否继续？",
        "",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          service
            .deleteProductLine({
              id: row.id,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.editForm.businessLineList.forEach((item, index) => {
                if (item.id === row.id) {
                  this.editForm.businessLineList.splice(index, 1);
                }
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      console.log(this.editForm.businessLineList, "this.editForm.businessLineList");
    },
  },
  destroyed() {
    this.timer = null;
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";

.dialog-add-busi {
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
.custom-select-item {
  width: 500px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-item-left {
  width: 350px;
  margin-right: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tooltip__popper.is-dark {
  max-width: 1000px;
}
.sub-header {
  width: 100%;
  height: 30px;
  margin: 5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  justify-content: space-between;
  background: #f0f3ff;
  color: #7a84b7;
  font-size: 16px;
  span {
    margin: 0 10px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.dialog-wrap .add-edit-form {
  flex: initial;
}
</style>
